import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogBody, DialogActions, Button, Label, Select, Field } from '../ui';
import { useActiveTenant } from '../../contexts/ActiveTenantContext';

interface TenantSwitcherProps {
  isOpen: boolean;
  onClose: () => void;
}

const TenantSwitcher: React.FC<TenantSwitcherProps> = ({ isOpen, onClose }) => {
  const { activeTenantId, availableTenants, setActiveTenantId } = useActiveTenant();
  const [selectedTenantId, setSelectedTenantId] = useState(activeTenantId || '');
  const hasSingleTenant = availableTenants.length === 1;

  const handleConfirm = () => {
    if (selectedTenantId) {
      setActiveTenantId(selectedTenantId);
      onClose();
    }
  };

  const handleCancel = () => {
    setSelectedTenantId(activeTenantId || '');
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>{hasSingleTenant ? 'Current Organization' : 'Switch Organization'}</DialogTitle>
      <DialogBody>
        {hasSingleTenant ? (
          <>
            <p>You are currently a member of only one organization:</p>
            <p className="font-bold">
              {availableTenants[0].tenantName} ({availableTenants[0].role})
            </p>
          </>
        ) : (
          <Field>
            <Label>Select an organization to switch to:</Label>
            <Select name="tenant-select" value={selectedTenantId} onChange={(e) => setSelectedTenantId(e.target.value)}>
              {availableTenants.map((tenant) => (
                <option key={tenant.tenantId} value={tenant.tenantId}>
                  {tenant.tenantName} ({tenant.role})
                </option>
              ))}
            </Select>
          </Field>
        )}
      </DialogBody>
      <DialogActions>
        {hasSingleTenant ? (
          <Button type="button" color="blue" onClick={onClose}>
            Close
          </Button>
        ) : (
          <>
            <Button type="button" plain onClick={handleCancel}>
              Cancel
            </Button>
            <Button type="button" color="blue" onClick={handleConfirm}>
              Confirm
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default TenantSwitcher;
